export default __webpack_public_path__ + "static/media/arrow-down_shurukuang@2X.113d539b.svg";